import React, { useEffect, useState } from 'react';
import AxelentLogo from 'assets/images/axelent-logo.svg';
import BottomMenu from 'components/BottomMenu/BottomMenu';
import ProductPanel from 'components/ProductPanel/ProductPanel';
import clsx from 'clsx';
import Gallery from 'components/Gallery/Gallery';
import Contact from 'components/Contact/Contact';
import DocumentsView from 'components/DocumentsView/DocumentsView';
import Share from 'components/Share/Share';
import About from 'components/About/About';
import Onboarding from 'components/Onboarding/Onboarding';
import AnimatedBox from 'components/AnimatedBox/AnimatedBox';
import { useSpring, animated } from 'react-spring';
import useStore from 'state/state';
import styles from './Overlay.module.scss';

const Overlay = () => {
  const isShareOpen = useStore((state) => state.isShareOpen);
  const isAboutOpen = useStore((state) => state.isAboutOpen);
  const isPcLoaded = useStore((state) => state.isPcLoaded);
  const mode = useStore((state) => state.mode);
  const isOnboardingOpen = useStore((state) => state.isOnboardingOpen);
  const productObject = useStore((state) => state.productObject);
  const isWhitePaperOpen = useStore((state) => state.isWhitePaperOpen);
  const isArticleOpen = useStore((state) => state.isArticleOpen);
  const isContactOpen = useStore((state) => state.isContactOpen);
  const isGalleryOpen = useStore((state) => state.isGalleryOpen);
  const isIntro = useStore((state) => state.isIntro);
  const [animateOutProductPanel, setAnimateOut] = useState(false);
  const animatedBoxStartPosition = useStore(
    (state) => state.animatedBoxStartPosition
  );
  const animatedBoxEndPosition = useStore(
    (state) => state.animatedBoxEndPosition
  );

  const productData = useStore((state) => state.productData);
  const props = useSpring({ to: { opacity: 1 }, from: { opacity: 0 } });

  useEffect(() => {
    if (isWhitePaperOpen || isArticleOpen || isContactOpen || isGalleryOpen) {
      setAnimateOut(true);
    }
    if (
      !isWhitePaperOpen &&
      !isArticleOpen &&
      !isContactOpen &&
      !isGalleryOpen
    ) {
      setAnimateOut(false);
    }
  }, [isWhitePaperOpen, isArticleOpen, isContactOpen, isGalleryOpen]);

  return (
    <div className={styles.wrapper}>
      {isPcLoaded && (
        <animated.div style={props}>
          <div
            className={clsx(styles.logo, {
              [styles.visible]:
                !isArticleOpen &&
                !isGalleryOpen &&
                !isWhitePaperOpen &&
                !isIntro,
            })}
          >
            <AxelentLogo />
          </div>
          <div
            className={clsx(styles.bottomMenu, {
              [styles.visible]:
                mode !== 'intro' &&
                !isArticleOpen &&
                !isGalleryOpen &&
                !isWhitePaperOpen,
            })}
          >
            <BottomMenu />
          </div>
        </animated.div>
      )}
      {animatedBoxStartPosition && animatedBoxEndPosition && (
        <AnimatedBox
          firstPosition={animatedBoxStartPosition}
          secondPosition={animatedBoxEndPosition}
          isGreen={isArticleOpen}
          isBlue={isContactOpen}
        />
      )}
      {productObject && (
        <div>
          <ProductPanel
            productId={productObject.id}
            productType={productObject.type}
            animateOut={animateOutProductPanel}
            setAnimateOut={setAnimateOut}
          />
        </div>
      )}
      {isWhitePaperOpen && productData && (
        <div className={styles.documentsView}>
          <DocumentsView isWhitePaper data={productData.whitepapers} />
        </div>
      )}
      {isArticleOpen && productData && (
        <div className={styles.documentsView}>
          <DocumentsView data={productData.articles} />
        </div>
      )}
      {isGalleryOpen && productData && (
        <div className={styles.gallery}>
          <Gallery data={productData.media} />
        </div>
      )}
      {isContactOpen && (
        <div className={styles.contact}>
          <Contact productAlias={productData.alias} />
        </div>
      )}
      {isShareOpen && (
        <div className={styles.share}>
          <Share />
        </div>
      )}
      {isAboutOpen && (
        <div className={styles.share}>
          <About />
        </div>
      )}
      {isOnboardingOpen && (
        <div className={styles.onboarding}>
          <Onboarding />
        </div>
      )}
    </div>
  );
};

export default Overlay;
